import { clientAppSettings } from '../Models/ClientAppSettings';

export class FlightUtils {
    public static get IsFirstPartyAuthFlighted(): boolean {
        const features = clientAppSettings.flightedFeatures;
        return _.contains(features, "firstPartyAuth");
    }

    public static get areMigrationRequiredBotsDisabled(): boolean {
        const features = clientAppSettings.flightedFeatures;
        return _.contains(features, "disableMigrationRequiredBots");
    }
}


// WEBPACK FOOTER //
// ./Client/Utils/FlightUtils.ts